import React from 'react';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons';

  import Icon from './IconColor';

const DollarSignIcon = ({ ToolTipText = 'Pay',  Color = 'black' }) => (
  <Icon tooltip={ToolTipText} iconObj={faDollarSign} color={Color} />
);

export default DollarSignIcon;